var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "edit-area" },
    [
      _c(
        "section",
        { staticClass: "edit-panel" },
        [
          _c("div", { staticClass: "panel-head" }, [
            _c("div", [
              _c(
                "div",
                { staticClass: "method-title" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t(
                          "QuotationCenter.components.copyPasteTip"
                        ),
                        placement: "top-start",
                      },
                    },
                    [_c("span", [_vm._v("!")])]
                  ),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("QuotationCenter.components.copyPasteMethod")
                      ) +
                      " "
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "panel-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", plain: "", icon: "el-icon-back" },
                    on: { click: _vm.handleClose },
                  },
                  [_vm._v(_vm._s(_vm.$t("QuotationCenter.components.back")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "mini",
                      plain: "",
                      icon: "el-icon-plus",
                      disabled: _vm.adjustmentPriceDisabled,
                    },
                    on: { click: _vm.onAdjustmentPrice },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("QuotationCenter.components.batchAdjustment")
                      )
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "primary-plain",
                    attrs: { size: "mini", plain: "" },
                    on: { click: _vm.onClear },
                  },
                  [_vm._v(_vm._s(_vm.$t("QuotationCenter.components.clear")))]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "primary-btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: !_vm.feeItem,
                    },
                    on: { click: _vm.onSave },
                  },
                  [
                    _c("i", { staticClass: "el-icon-check" }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("QuotationCenter.components.save"))
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "priceTableForm",
              staticClass: "price-table-form",
              attrs: { model: _vm.priceTableForm, rules: _vm.priceTableRules },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "priceTable",
                  staticClass: "price-table",
                  class: { "price-table--ready": _vm.tablesReady },
                  attrs: {
                    data: _vm.priceRows,
                    "show-header": true,
                    height: "360",
                    border: "",
                    script: "",
                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                  },
                  on: { "cell-click": _vm.handleCellClick },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("QuotationCenter.serialNumber"),
                      width: "54",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "packageType",
                      label: _vm.$t("QuotationCenter.packageType"),
                      align: "center",
                      "min-width": "133",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "priceRows." + $index + ".packageType",
                                  rules: _vm.priceTableRules.packageType,
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "option-list": _vm.QUOTATION_PACKAGE_TYPE,
                                  },
                                  model: {
                                    value: row.packageType,
                                    callback: function ($$v) {
                                      _vm.$set(row, "packageType", $$v)
                                    },
                                    expression: "row.packageType",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "zone",
                      label: _vm.$t("QuotationCenter.zone"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "priceRows." + $index + ".zone",
                                  rules: _vm.priceTableRules.zone,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder: _vm.$t("inputText"),
                                  },
                                  model: {
                                    value: row.zone,
                                    callback: function ($$v) {
                                      _vm.$set(row, "zone", $$v)
                                    },
                                    expression: "row.zone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "startWeight",
                      label: _vm.$t("QuotationCenter.start"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "priceRows." + $index + ".startWeight",
                                  rules: _vm.priceTableRules.startWeight,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder: _vm.$t("inputText"),
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.validateWeightRow($index)
                                    },
                                  },
                                  model: {
                                    value: row.startWeight,
                                    callback: function ($$v) {
                                      _vm.$set(row, "startWeight", $$v)
                                    },
                                    expression: "row.startWeight",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "endWeight",
                      label: _vm.$t("QuotationCenter.end"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "priceRows." + $index + ".endWeight",
                                  rules: _vm.priceTableRules.endWeight,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder: _vm.$t("inputText"),
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.validateWeightRow($index)
                                    },
                                  },
                                  model: {
                                    value: row.endWeight,
                                    callback: function ($$v) {
                                      _vm.$set(row, "endWeight", $$v)
                                    },
                                    expression: "row.endWeight",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "calcMethod",
                      label: _vm.$t("QuotationCenter.calcMethod"),
                      align: "center",
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "priceRows." + $index + ".calcMethod",
                                  rules: _vm.priceTableRules.calcMethod,
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "option-list": _vm.QUOTATION_CALC_METHOD,
                                  },
                                  model: {
                                    value: row.calcMethod,
                                    callback: function ($$v) {
                                      _vm.$set(row, "calcMethod", $$v)
                                    },
                                    expression: "row.calcMethod",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unitWeight",
                      label: _vm.$t("QuotationCenter.components.roundingUnit"),
                      align: "center",
                      width: "118",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "priceRows." + $index + ".unitWeight",
                                  rules: _vm.priceTableRules.unitWeight,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder: _vm.$t("inputText"),
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.validateWeightRow($index)
                                    },
                                  },
                                  model: {
                                    value: row.unitWeight,
                                    callback: function ($$v) {
                                      _vm.$set(row, "unitWeight", $$v)
                                    },
                                    expression: "row.unitWeight",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unitPrice",
                      label: _vm.$t("QuotationCenter.components.unitPrice"),
                      align: "center",
                      width: "95",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "priceRows." + $index + ".unitPrice",
                                  rules: _vm.priceTableRules.unitPrice,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder: _vm.$t("inputText"),
                                  },
                                  model: {
                                    value: row.unitPrice,
                                    callback: function ($$v) {
                                      _vm.$set(row, "unitPrice", $$v)
                                    },
                                    expression: "row.unitPrice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "minimumCharge",
                      label: _vm.$t("QuotationCenter.components.minimumCharge"),
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "priceRows." + $index + ".minimumCharge",
                                  rules: _vm.priceTableRules.minimumCharge,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder: _vm.$t("inputText"),
                                  },
                                  model: {
                                    value: row.minimumCharge,
                                    callback: function ($$v) {
                                      _vm.$set(row, "minimumCharge", $$v)
                                    },
                                    expression: "row.minimumCharge",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table.operationText"),
                      align: "center",
                      width: "100",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var $index = ref.$index
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete($index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "button",
            {
              staticClass: "add-row",
              attrs: { type: "button" },
              on: { click: _vm.onAddRow },
            },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(_vm._s(_vm.$t("QuotationCenter.components.addRow")) + " "),
            ]
          ),
        ],
        1
      ),
      _c("QuotationImportPanel", {
        ref: "importPanel",
        attrs: {
          loading: _vm.importLoading,
          importable: !!(_vm.feeItem && _vm.feeItem.id),
        },
        on: { closed: _vm.resetImportState, confirm: _vm.confirmImport },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("QuotationCenter.components.batchAdjustment"),
            visible: _vm.adjustmentDialogVisible,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.adjustmentDialogVisible = $event
            },
            closed: _vm.resetAdjustmentForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "adjustmentForm",
              staticClass: "adjustment-form",
              attrs: {
                model: _vm.adjustmentForm,
                rules: _vm.adjustmentRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("QuotationCenter.components.adjustmentType"),
                    prop: "type",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: { size: "small" },
                      on: { change: _vm.handleAdjustmentTypeChange },
                      model: {
                        value: _vm.adjustmentForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.adjustmentForm, "type", $$v)
                        },
                        expression: "adjustmentForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t(
                            "QuotationCenter.components.fixedAmountAdjustment"
                          ),
                          value: "fixed",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t(
                            "QuotationCenter.components.percentAdjustment"
                          ),
                          value: "percent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.adjustmentForm.type === "fixed"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("QuotationCenter.components.fixedAmount"),
                        prop: "amount",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          clearable: "",
                          placeholder: _vm.$t(
                            "QuotationCenter.components.adjustmentPlaceholder"
                          ),
                        },
                        model: {
                          value: _vm.adjustmentForm.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.adjustmentForm, "amount", $$v)
                          },
                          expression: "adjustmentForm.amount",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.adjustmentForm.type === "percent"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "QuotationCenter.components.percentAmount"
                        ),
                        prop: "percent",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: _vm.$t(
                              "QuotationCenter.components.adjustmentPlaceholder"
                            ),
                          },
                          model: {
                            value: _vm.adjustmentForm.percent,
                            callback: function ($$v) {
                              _vm.$set(_vm.adjustmentForm, "percent", $$v)
                            },
                            expression: "adjustmentForm.percent",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("%")])],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.adjustmentDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("QuotationCenter.components.close")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmAdjustmentPrice },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("QuotationCenter.components.confirmAdjustment")
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }